export default __webpack_public_path__ + "static/media/brago-screenshot-03.c036c0fd.png";